import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Me } from "../api/users";
import { PostGet } from "../api/post";
import { DirectorLevel } from "../constants";

const REPORT_SECTIONS = [
  {
    title: "Согласования и операции",
    items: [
      {
        to: "/report-food",
        title: "Отчет по еде",
        description: "Учет приема пищи сотрудниками",
      },
      {
        to: "/report-approve-mng",
        title: "Отчет по согласованию МНГ",
        description: "Статус согласований менеджеров",
      },
      {
        to: "/report-service-notes",
        title: "Служебные записки",
        description: "Изменения расписания ЧК после согласования ТУ",
        minLevel: 20,
      },
      {
        to: "/report-approve-chk",
        title: "Отчет по согласованию ЧК",
        description: "Статус согласований чеклистов",
      },
      {
        to: "/report-FT",
        title: "Отчет по FT",
        description: "Данные по full-time сотрудникам",
      },
    ],
  },
  {
    title: "Смены",
    items: [
      {
        to: "/report-shifts",
        title: "Отчет по сменам",
        description: "Расписание и отработанные смены",
      },
      {
        to: "/report-nmg-shedule-only-directors",
        title: "Отчет МНГ по сменам директоров",
        description: "Смены директоров в разрезе МНГ",
      },
    ],
  },
  {
    title: "Мотивация",
    items: [
      {
        to: "/reports-motivation",
        title: "Отчет по мотивации",
        description: "Показатели и премии сотрудников",
        minLevel: 12,
      },
      {
        to: "/reports-motivationMNG",
        title: "Отчет по мотивации МНГ",
        description: "Мотивация менеджеров",
        minLevel: 12,
      },
    ],
  },
  {
    title: "Прочее",
    items: [
      {
        to: "/report-deployment-accuracy",
        title: "Точность попадания в деплоймент",
        description: "Сравнение плановых часов смен и факта по отметкам",
        minLevel: DirectorLevel,
      },
      {
        to: "/report-payroll",
        title: "Расчёт ЗП",
        description: "Оплата по отметкам Boss Control в рамках смен",
        minLevel: 40,
      },
      {
        to: "/report-energy",
        title: "Отчет по электроэнергии",
        description: "Потребление электроэнергии",
        minLevel: 20,
      },
      {
        to: "/report-employee",
        title: "Табель учёта рабочего времени",
        description: "План, факт Boss Control и отклонения по сменам",
        minLevel: DirectorLevel,
      },
    ],
  },
];

const Reports = ({ token }) => {
  const [access_level, setAccessLevel] = useState(0);

  const fetchProfile = async () => {
    try {
      const user = await Me(token);
      const PostData = await PostGet(token, user.post_id);
      setAccessLevel(PostData.access_level);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  const visibleSections = REPORT_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(
      (item) => access_level >= (item.minLevel ?? 0),
    ),
  })).filter((section) => section.items.length > 0);

  return (
    <div className="reports-page container">
      <h1>Отчёты</h1>

      {visibleSections.map((section) => (
        <section key={section.title}>
          <h2 className="reports-section-title">{section.title}</h2>
          <div className="row g-3">
            {section.items.map((item) => (
              <div key={item.to} className="col-md-6 col-lg-4">
                <Link to={item.to} className="report-card-link">
                  <div className="card report-card">
                    <div className="card-body">
                      <h3 className="card-title">{item.title}</h3>
                      <p className="card-text">{item.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Reports;